import { render, staticRenderFns } from "./BlogBox.vue?vue&type=template&id=da058cb0&scoped=true"
import script from "./BlogBox.vue?vue&type=script&lang=js"
export * from "./BlogBox.vue?vue&type=script&lang=js"
import style0 from "./BlogBox.vue?vue&type=style&index=0&id=da058cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da058cb0",
  null
  
)

export default component.exports